import {
  getCivilDateToday,
  getCivilDateDayOfWeek,
  getCivilDateMonthStart,
} from '@bingads-webui-universal/temporal-utitlities';
import { modelI18nMock } from '@bingads-webui-test/i18n-mock';
import { CivilDate } from 'tc39-proposal-temporal';
import './styles/date-range-picker.less';

const today = getCivilDateToday();
const yesterday = today.plus({ days: -1 });
const thisSunday = today.plus({ days: -getCivilDateDayOfWeek(today) });
const lastSunday = today.plus({ days: -getCivilDateDayOfWeek(today) - 7 });
const lastSaturday = today.plus({ days: -getCivilDateDayOfWeek(today) - 1 });
const thisMonthFirstDay = getCivilDateMonthStart(today);
const lastMonthlastDay = thisMonthFirstDay.plus({ days: -1 });
const lastMonthFirstDay = getCivilDateMonthStart(lastMonthlastDay);
const specificRanges = [
  {
    rangeId: 1, key: 'Custom', text: 'Custom', range: { start: undefined, end: undefined },
  },
  {
    rangeId: 2, key: 'Today', text: 'Today', range: { start: today, end: today },
  },
  {
    rangeId: 3, key: 'Yesterday', text: 'Yesterday', range: { start: yesterday, end: yesterday },
  },
  {
    rangeId: 4, key: 'ThisWeek', text: 'This Week', range: { start: thisSunday, end: today },
  },
  {
    rangeId: 5, key: 'LastWeek', text: 'Last Week', range: { start: lastSunday, end: lastSaturday },
  },
  {
    rangeId: 6, key: 'ThisMonth', text: 'This Month', range: { start: thisMonthFirstDay, end: today },
  },
  {
    rangeId: 7, key: 'LastMonth', text: 'Last Month', range: { start: lastMonthFirstDay, end: lastMonthlastDay },
  },
  {
    rangeId: 8, key: 'Any', text: 'Any', range: { start: today.plus({ years: -1 }), end: today },
  },
];

const componentStrings = {
  selected: 'Selection: ',
  compared: 'Compared',
  apply: 'Apply',
  close: 'Close',
  Today: 'Today',
  Custom: 'Custom',
  Yesterday: 'Yesterday',
  ThisWeek: 'This week',
  LastWeek: 'Last week',
  ThisMonth: 'This month',
  LastMonth: 'Last month',
  LastYear: 'Last year',
  LastPeriod: 'Last period',
  Any: 'Any',
};

// TODO: Replace the mock with real i18n
const i18nMock = modelI18nMock({ dictionary: componentStrings });
i18nMock.getString = key => key;
const date = i18nMock.getToday();
const getToday = () => new CivilDate(date.year, date.month, date.day);
i18nMock.getToday = getToday;

export {
  today,
  yesterday,
  thisSunday,
  lastSunday,
  lastSaturday,
  thisMonthFirstDay,
  lastMonthlastDay,
  lastMonthFirstDay,
  specificRanges,
  i18nMock,
};
